module.exports = __webpack_public_path__ + "static/media/08-multi.3a6a9925.png";